import React from 'react';
import './form-input.styles.scss';

const formInput = ({handleChange, label, type, ...otherItemProps}) => (
    <div className="group">
        <input className="form-input" onChange={handleChange} type={type} {...otherItemProps}/>
        
    </div>
)
export default formInput;